// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { createOnlineCourseNotes } from '../../../apis/onlineCourse';
import { parseCamelCase } from '../../../apis/util';
import { RootAction, actionCreatorsList } from '../../rootActionCreator';
const { createOnlineCourseNoteActions } = actionCreatorsList;

const outputActions = {
  success: createOnlineCourseNoteActions.success,
  failure: createOnlineCourseNoteActions.failure
};

type RequestActionTypes = ActionType<
  typeof createOnlineCourseNoteActions.request
>;
type OutputActionTypes = ActionType<typeof outputActions>;

const getOnlineCourseContentsDataEpic = (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      // action filter
      getType(createOnlineCourseNoteActions.request)
    ),
    concatMap((action: RequestActionTypes) => {
      // prepare api params
      const { id, vodId, time, message } = action.payload;

      // send api promise
      return createOnlineCourseNotes(id, vodId, time, message)
        .then(response => {
          const notes = response.data.message.notes;
          // handle success case here
          const parsedNotes = parseCamelCase(notes).map((note:any) => ({
            ...note,
            message: note.note,
            note: undefined
          }));
          return createOnlineCourseNoteActions.success({
            id,
            notes: parsedNotes
          });
        })
        .catch((error: AxiosError) => {
          // handle error case here
          console.log(error)
          return createOnlineCourseNoteActions.failure({ error });
        });
    })
  );
};

export { getOnlineCourseContentsDataEpic as default};
